import { Pagination } from '@/domain/entities/Pagination'

export class GuideCategoryData {
  private id: number
  private name: string
  private tag: string
  private totalFiles: number
  private isActive: boolean
  private imageThumbnail: string
  private imageCover: string
  private imageLogo: string
  private createdAt: string
  private updatedAt: string

  constructor(
    id: number,
    name: string,
    tag: string,
    totalFiles: number,
    isActive: boolean,
    imageThumbnail: string,
    imageCover: string,
    imageLogo: string,
    createdAt: string,
    updatedAt: string
  ) {
    this.id = id
    this.name = name
    this.tag = tag
    this.totalFiles = totalFiles
    this.isActive = isActive
    this.imageThumbnail = imageThumbnail
    this.imageCover = imageCover
    this.imageLogo = imageLogo
    this.createdAt = createdAt
    this.updatedAt = updatedAt
  }
}

export class GuideCategory {
  public success: boolean
  public message: string
  public pagination?: Pagination
  public data?: GuideCategoryData[]

  constructor(
    success: boolean,
    message: string,
    pagination?: Pagination,
    data?: GuideCategoryData[]
  ) {
    this.success = success
    this.message = message
    this.pagination = pagination
    this.data = data
  }
}
